import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { getReservations, checkIn, checkOut, cancel, getEmailTemplates, sendMail, getEmails, addCancellationCharge, addSystemFeeRecord, deleteSystemFeeRecord } from '../utils/OpenCampground_Database_Calls'
import SearchBar from "material-ui-search-bar";
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import View from './View';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import reservations from '../assets/reservation.png'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import '../CSS/Reservations.css';
import TextField from "@mui/material/TextField";
import { format } from 'date-fns';
import dayjs from "dayjs";

const useStyles = theme => ({
    circularProgress: {
        position: 'absolute',
        left: '55%',
        top: '50%',
        color: '#2dcd7a'
    },
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
        minWidth: '600px',
    }
});

const numericFields = new Set(['amount_paid', 'total', 'tax_amount', 'id']);

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

const reasonMap = {
    change_of_plans: "Change of plans, no longer need the reservation",
    weather: "Severe weather or unsafe conditions",
    illness: "Illness or medical emergency",
    family_emergency: "Family emergency requiring travel changes",
    work_conflict: "Work schedule conflicts",
    financial_constraints: "Unexpected financial constraints",
    vehicle_issues: "RV, boat, or vehicle issues",
    incorrect_booking: "Incorrect date, site type, or location booked",
    group_canceled: "Group or travel companions canceled",
    event_canceled: "Event cancellation or rescheduling",
    travel_restrictions: "Illness, exposure, or travel restrictions",
    safety_concerns: "Safety concerns about the site or area",
    better_accommodation: "Found a better-suited accommodation",
    not_meet_expectations: "Site does not meet expectations or needs",
    road_closures: "Road closures or government travel restrictions",
    overbooking: "Reservation canceled due to overbooking",
    maintenance: "Site closed for maintenance or repairs",
    extreme_weather: "Extreme weather affecting site access",
    health_safety: "Health or safety issues at the property",
    policy_conflict: "Policy conflict",
    payment_issues: "Payment issues or failed transaction",
    prior_misconduct: "Prior misconduct or policy violations",
    staffing_shortages: "Staffing shortages affecting operations",
    facility_issues: "Power, water, or facility issues",
    legal_changes: "Legal or regulatory changes",
    no_show: "No Show"
};

class Reservations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reservations: [],
            allReservations: null,
            currentPage: 1,
            searchValue: '',
            searchById: true,
            searchByName: false,
            showAllReservations: true,
            showReservations: false,
            showCheckedInReservations: false,
            view: false,
            viewItem: {},
            open: false,
            confirm: false,
            popupText: '',
            reservationToHandle: null,
            action: null,
            confirmationOpen: false,
            confirmationText: '',
            popupTitle: '',
            confirmationTitel: '',
            //email
            reservationCancelMailMessage: '',
            reservationCancelSubject: '',
            reservationCancelAttachments: [],
            reservationFeedbackMailMessage: '',
            reservationFeedbackSubject: '',
            reservationFeedbackAttachments:[],
            sender: '',
            reply: '',
            cc: '',
            bcc: '',
            noReservations: false,
            searchType: 'name',
            cancellationReason: '',
            cancellationCharge: '',
            sortConfig: {
                key: null,
                direction: 'asc'
            }
        };
    }

    async componentDidMount() {
        let mailMessages = await getEmailTemplates(this.props.user, this.props.serverName)
        let email = await getEmails(this.props.user, this.props.serverName)
        this.setState({
            reservationCancelMailMessage: mailMessages[7].body,
            reservationCancelSubject: email.reservation_cancel_subject,
            reservationCancelAttachments: mailMessages[7].attachments,
            reservationFeedbackMailMessage: mailMessages[2].body,
            reservationFeedbackSubject: email.feedback_subject,
            reservationFeedbackAttachments: mailMessages[2].attachments,
            sender: email.sender,
            reply: email.reply,
            cc: email.cc,
            bcc: email.bcc,
        })
        this.reservations()
    }

    reservations = async () => {
        let listOfReservations = await getReservations(this.props.user, this.props.serverName);
        console.log(listOfReservations)
        console.log(listOfReservations.length === 0 ? true : false)
        this.setState({
            reservations: listOfReservations,
            allReservations: listOfReservations,
        })
    }

    getReservationsByName = async (value) => {
        let filteredReservations = this.state.allReservations.filter(reservation => {
            const searchValue = value.toLowerCase();

            return (
                (reservation.first_name && reservation.first_name.toLowerCase().includes(searchValue)) ||
                (reservation.last_name && reservation.last_name.toLowerCase().includes(searchValue)) ||
                (reservation.id && reservation.id.toString().includes(searchValue)) ||
                (reservation.amount_paid && `$${reservation.amount_paid}`.includes(searchValue)) ||
                ((reservation.first_name && reservation.last_name) && (`${reservation.first_name.toLowerCase()} ${reservation.last_name.toLowerCase()}`).includes(searchValue))
            );
        }
        );
        this.setState({
            value: '',
            reservations: filteredReservations,
            noReservations: filteredReservations.length > 0 ? false : true
        });
    }

    getReservationsByReservationNumber = (value) => {
        const filteredReservations = this.state.allReservations.filter(reservation =>
            reservation.id.toString().includes(value)
        );
        this.setState({
            value: '',
            reservations: filteredReservations,
            noReservations: filteredReservations.length > 0 ? false : true
        });
    }

    displayAllReservations = async () => {
        this.setState({
            reservations: this.state.allReservations,
            noReservations: false
        })
    }

    replaceMailTemplatePlaceHolders = (type, reservationNumber, camper, startDate, endDate) => {
        let mailMessage
        if (type === "feedback") {
            mailMessage = this.state.reservationFeedbackMailMessage
        } else {
            mailMessage = this.state.reservationCancelMailMessage
        }
        if (type === "cancel") {
            mailMessage = mailMessage.replace('{{reason}}', reasonMap[this.state.cancellationReason] || "Unknown reason");
        }
        mailMessage = mailMessage.replace('{{camper}}', camper);
        mailMessage = mailMessage.replace('{{number}}', reservationNumber);
        mailMessage = mailMessage.replace('{{start}}', startDate);
        mailMessage = mailMessage.replace('{{departure}}', endDate);
        return mailMessage
    }

    openPopup = async (reservationItem, action) => {
        console.log(reservationItem)
        let popupText = "";
        let popupTitel = "";
        switch (action) {
            case "checkOut":
                popupTitel = "Confirm Check out"
                popupText = "Proceed with check out for Site Name:" + reservationItem.sitename + ". Reservation number: " + reservationItem.id + ". Ensure all charges are settled."
                break;
            case "checkIn":
                popupTitel = "Confirm Check-In"
                popupText = "Proceed with check-in for " + reservationItem.first_name + " " + reservationItem.last_name + ". Reservation number: " + reservationItem.id + "."
                break;
            case "cancel":
                popupTitel = "Confirm Cancellation"
                popupText = "Proceed with cancellation for Reservation number: " + reservationItem.id + "."
                break;
            default:
                popupText = "";
        }

        this.setState({
            open: true,
            popupTitle: popupTitel,
            popupText: popupText,
            reservationToHandle: reservationItem,
            action: action
        });
    }

    handleConfirm = async () => {
        const { action, reservationToHandle } = this.state;
        this.setState({ confirm: true, open: false });
        let confirmationText = '';
        let confirmationTitel = '';
        let mailmessage = '';
        let mailResponse = null
        switch (action) {
            case "checkOut":
                await checkOut(this.props.user, this.props.serverName, reservationToHandle.id, format(new Date(), 'MM/dd/yyyy'));
                mailmessage = this.replaceMailTemplatePlaceHolders("feedback", reservationToHandle.id, reservationToHandle.first_name + ' ' + reservationToHandle.last_name)
                mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, reservationToHandle.email, this.state.reservationFeedbackSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.reservationFeedbackAttachments)
                confirmationTitel = "Guest Checked out"
                confirmationText = "Site Name:" + reservationToHandle.sitename + ". Reservation number: " + reservationToHandle.id + ".";
                break;
            case "checkIn":
                await checkIn(this.props.user, this.props.serverName, reservationToHandle.id, format(new Date(), 'MM/dd/yyyy'));
                confirmationTitel = "Guest Checked-In"
                confirmationText = "Reservation Number: " + reservationToHandle.id + ". Site Name:" + reservationToHandle.sitename + ". Start Date:" + reservationToHandle.startdate + " End Date: " + reservationToHandle.enddate + ".";
                break;
            case "cancel":
                await cancel(this.props.user, this.props.serverName, reservationToHandle.id, format(new Date(), 'MM/dd/yyyy'));
                const createdAt = dayjs(reservationToHandle.created_at);
                const now = dayjs();
                const isWithin24Hours = now.diff(createdAt, 'hour') <= 24;
                if(!isWithin24Hours){
                    let response2 = await addSystemFeeRecord(this.props.serverName, reservationToHandle.id, reservationToHandle.startdate, reservationToHandle.enddate, 'manager', 'cancel')
                } else{
                    let response2 = await deleteSystemFeeRecord(this.props.serverName, reservationToHandle.id)
                }
                mailmessage = this.replaceMailTemplatePlaceHolders("cancel", reservationToHandle.id, reservationToHandle.first_name + ' ' + reservationToHandle.last_name, reservationToHandle.startdate, reservationToHandle.enddate)
                mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, reservationToHandle.email, this.state.reservationCancelSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.reservationCancelAttachments)
                let response = await addCancellationCharge(this.props.user, this.props.serverName, reservationToHandle.id, this.state.cancellationCharge, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
                confirmationTitel = "Reservation Cancelled"
                confirmationText = "Reservation Number: " + reservationToHandle.id + ".";
                this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=transactions&searchValue=${reservationToHandle.id}`)
                break;
            default:
                break;
        }
        this.setState({
            confirmationOpen: true,
            confirmationTitel: confirmationTitel,
            confirmationText: confirmationText
        });
        this.reservations();
    };

    handleCancel = () => {
        this.setState({ confirm: false, open: false });
        console.log("canceled");
    };

    filterClick = (type) => {
        let filteredReservations;
        if (type === 'reserved') {
            filteredReservations = this.state.allReservations.filter(reservation => reservation.checked_in === 0);
        } else if (type === 'checkedIn') {
            filteredReservations = this.state.allReservations.filter(reservation => reservation.checked_in === 1);
        } else if (type === 'groups') {
            filteredReservations = this.state.allReservations.filter(reservation => reservation.group_id !== null);
        }else if (type === 'review') {
            filteredReservations = this.state.allReservations.filter(reservation => reservation.unconfirmed_remote === 1);
        } else if (type === 'checkingOut') {
            filteredReservations = this.state.allReservations.filter(reservation => {
                const inputDate = new Date(reservation.enddate);
                const today = new Date();
                inputDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const isSameDate = inputDate.getTime() === today.getTime();
                return isSameDate
                });   
        } else {
            filteredReservations = this.state.allReservations;
        }
        this.setState({
            reservations: filteredReservations,
            noReservations: filteredReservations.length > 0 ? false : true
        });
    }

    view = async (viewItem) => {
        this.setState({
            viewItem: viewItem,
            view: true
        })
    }

    goBack = () => {
        this.setState({
            view: false,
            viewItem: {}
        });
        this.reservations()
    }

    handleSort = (columnKey) => {
        this.setState((prevState) => {
          const { sortConfig } = prevState;
      
          if (sortConfig.key === columnKey) {
            if (sortConfig.direction === 'asc') {
              return { sortConfig: { key: columnKey, direction: 'desc' } };
            } else if (sortConfig.direction === 'desc') {
              // Reset sort
              return { sortConfig: { key: null, direction: null } };
            }
          }
      
          return { sortConfig: { key: columnKey, direction: 'asc' } };
        });
      };

    render() {
        const { classes } = this.props;
        let reservationRows, previousButton, nextButton, lastButton
        let paginationButtons = []
        if (!this.state.noReservations && this.state.allReservations != null) {
            const itemsPerPage = 10;
            const totalPages = Math.ceil(this.state.reservations.length / itemsPerPage);
            let currentPage = this.state.currentPage || 1;

            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = Math.min(startIndex + itemsPerPage, this.state.reservations.length);

            const reservationsOnPage = this.state.reservations.slice(startIndex, endIndex);

            // const sortedReservations = reservationsOnPage.sort((a, b) => {
            //     console.log('calculation of sort');
            //     const { key, direction } = this.state.sortConfig;
            //     if (!key) return 0;
            
            //     const aVal = a[key]?.toString().toLowerCase() || '';
            //     const bVal = b[key]?.toString().toLowerCase() || '';
            
            //     if (aVal < bVal) return direction === 'asc' ? -1 : 1;
            //     if (aVal > bVal) return direction === 'asc' ? 1 : -1;
            //     return 0;
            // });

            let sortedReservations = this.state.reservations.slice(startIndex, endIndex);
            const { key, direction } = this.state.sortConfig;
            if (key && direction) {
                sortedReservations.sort((a, b) => {
                let valA = a[key];
                let valB = b[key];
                const isNumeric = numericFields.has(key);
                if (isNumeric) {
                    if(key === 'total'){
                        const safeParse = (value) => parseFloat(value ?? 0);
                        valA = safeParse(a['total']) + safeParse(a['tax_amount']) - safeParse(a['amount_paid']);
                        valB = safeParse(b['total']) + safeParse(b['tax_amount']) - safeParse(b['amount_paid']);
                    } else{
                        valA = parseFloat(valA);
                        valB = parseFloat(valB);
                    }
                } else {
                    if(key=='rigname'){
                        if(!a[key])
                            valA = a['group_name'].toString().toLowerCase() || ''
                        else
                        valA = a[key].toString().toLowerCase() || ''
                        if(!b[key])
                            valB = b['group_name'].toString().toLowerCase() || ''
                        else
                        valB = b[key].toString().toLowerCase() || ''
                    }
                    else{
                        const isNumberA = !isNaN(valA) && valA !== '';
                        const isNumberB = !isNaN(valB) && valB !== '';
                        if (isNumberA && isNumberB) {
                            valA = parseFloat(valA);
                            valB = parseFloat(valB);
                        }
                        else{
                            valA = valA?.toString().toLowerCase() || '';
                            valB = valB?.toString().toLowerCase() || '';
                        }
                    }
                }
                console.log(valA,valB);
                if (valA < valB) return direction === 'asc' ? -1 : 1;
                if (valA > valB) return direction === 'asc' ? 1 : -1;
                return 0;
                });
            }

            reservationRows = sortedReservations.map((item) => {
                return (
                    <tr key={item.id} className='reservationRows'>
                        <td>{item.id}</td>
                        <td>{item.first_name} {item.last_name}</td>
                        <td>{item.group_name ? "Group Name: " + item.group_name : item.rigname}</td>
                        <td>{item.startdate}</td>
                        <td>{item.enddate}</td>
                        <td>{item.sitename}</td>
                        <td>${parseFloat(item.amount_paid).toFixed(2)}</td>
                        <td>${((parseFloat(item.total||0) + parseFloat(item.tax_amount||0)) - parseFloat(item.amount_paid||0) - parseFloat(item.onetime_discount||0)).toFixed(2)}</td>
                        <td style={{
                            color: item.unconfirmed_remote === 1 ? '#FB8100' :
                                item.checked_in === 0 ? '#000000' : '#01AE00'
                        }}>
                            {item.unconfirmed_remote === 1 ? 'Review' :
                                item.checked_in === 0 ? 'Reserved' : 'Checked In'}
                        </td>
                        <td className='actions'>
                            <div className='actionButtons'>
                                {item.unconfirmed_remote === 1
                                    ?
                                    <>
                                        <Button
                                            className='selectButton'
                                            onClick={() => this.view(item)}
                                            style={{ backgroundColor: '#999999', color: '#ffffff', padding: '2% 10% 2% 10%', borderRadius: '10px', textTransform: "capitalize" }}
                                        >
                                            View
                                        </Button>
                                    </>
                                    :
                                    <>
                                        {item.checked_in === 0
                                            ?
                                            <>
                                                <Button
                                                    className='selectButton'
                                                    onClick={() => this.view(item)}
                                                    style={{ backgroundColor: '#999999', color: '#ffffff', padding: '2% 10% 2% 10%', borderRadius: '10px', textTransform: "capitalize" }}
                                                >
                                                    View
                                                </Button>
                                                <Button
                                                    className='selectButton'
                                                    onClick={() => this.openPopup(item, "checkIn")}
                                                    style={{ whiteSpace: "nowrap", backgroundColor: '#EAFAE8', color: '#01AE00', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                                >
                                                    Check In
                                                </Button>
                                                <Button
                                                    className='selectButton'
                                                    onClick={() => this.openPopup(item, "cancel")}
                                                    style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                                >
                                                    Cancel
                                                </Button>
                                            </>
                                            :
                                            <>
                                                <Button
                                                    className='selectButton'
                                                    onClick={() => this.view(item)}
                                                    style={{ backgroundColor: '#999999', color: '#ffffff', padding: '2% 10% 2% 10%', borderRadius: '10px', textTransform: "capitalize" }}
                                                >
                                                    View
                                                </Button>
                                                <Button
                                                    className='selectButton'
                                                    onClick={() => this.openPopup(item, "checkOut")}
                                                    style={{ whiteSpace: "nowrap", backgroundColor: '#3671CE', color: '#ffffff', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                                >
                                                    Check Out
                                                </Button>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </td>
                    </tr>
                );
            });

            paginationButtons = [];
            const maxButtonsToShow = 10;
            let startPage, endPage;

            if (totalPages <= maxButtonsToShow) {
                startPage = 1;
                endPage = totalPages;
            } else {
                const maxPagesBeforeCurrentPage = Math.floor(maxButtonsToShow / 2);
                const maxPagesAfterCurrentPage = Math.ceil(maxButtonsToShow / 2) - 1;
                if (currentPage <= maxPagesBeforeCurrentPage) {
                    startPage = 1;
                    endPage = maxButtonsToShow;
                } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
                    startPage = totalPages - maxButtonsToShow + 1;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - maxPagesBeforeCurrentPage;
                    endPage = currentPage + maxPagesAfterCurrentPage;
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                paginationButtons.push(
                    <Button className={`paginationButton ${currentPage === i ? "activePage" : ""}`} key={i} onClick={() => this.setState({ currentPage: i })}>
                        {i}
                    </Button>
                );
            }

            previousButton = (
                <Button className='previousButton' disabled={currentPage === 1} onClick={() => this.setState({ currentPage: currentPage - 1 })}>
                    <ArrowBackIosIcon />
                </Button>
            );

            nextButton = (
                <Button className='nextButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: currentPage + 1 })}>
                    <ArrowForwardIosIcon />
                </Button>
            );

            lastButton = (
                <Button className='paginationButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: totalPages })}>
                    {totalPages}
                </Button>
            );
        }
        if (this.state.reservations.length > 0 || this.state.noReservations) {
            return (
                <Grid className='reservationList'>
                    {!this.state.view
                        ?
                        <>
                            <ThemeProvider theme={theme}>
                                <Dialog open={this.state.open} onClose={this.handleCancel} classes={{ paper: classes.dialogPaper }}>
                                    <DialogTitle>{this.state.popupTitle}</DialogTitle>
                                    <DialogContent>
                                        {this.state.popupText}
                                        {this.state.action === 'cancel'
                                            ?
                                            <>
                                                <div style={{ display: 'flex', marginTop: '5%' }}>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Reason for Cancellation
                                                    </Typography>
                                                    <Select
                                                        value={this.state.cancellationReason}
                                                        onChange={(e) => this.setState({ cancellationReason: e.target.value })}
                                                        displayEmpty
                                                        fullWidth
                                                    >
                                                        <MenuItem value="">Select a reason</MenuItem>
                                                        <MenuItem value="change_of_plans">Change of plans, no longer need the reservation</MenuItem>
                                                        <MenuItem value="weather">Severe weather or unsafe conditions</MenuItem>
                                                        <MenuItem value="illness">Illness or medical emergency</MenuItem>
                                                        <MenuItem value="family_emergency">Family emergency requiring travel changes</MenuItem>
                                                        <MenuItem value="work_conflict">Work schedule conflicts</MenuItem>
                                                        <MenuItem value="financial_constraints">Unexpected financial constraints</MenuItem>
                                                        <MenuItem value="vehicle_issues">RV, boat, or vehicle issues</MenuItem>
                                                        <MenuItem value="incorrect_booking">Incorrect date, site type, or location booked</MenuItem>
                                                        <MenuItem value="group_canceled">Group or travel companions canceled</MenuItem>
                                                        <MenuItem value="event_canceled">Event cancellation or rescheduling</MenuItem>
                                                        <MenuItem value="travel_restrictions">Illness, exposure, or travel restrictions</MenuItem>
                                                        <MenuItem value="safety_concerns">Safety concerns about the site or area</MenuItem>
                                                        <MenuItem value="better_accommodation">Found a better-suited accommodation</MenuItem>
                                                        <MenuItem value="not_meet_expectations">Site does not meet expectations or needs</MenuItem>
                                                        <MenuItem value="road_closures">Road closures or government travel restrictions</MenuItem>
                                                        <MenuItem value="overbooking">Reservation canceled due to overbooking</MenuItem>
                                                        <MenuItem value="maintenance">Site closed for maintenance or repairs</MenuItem>
                                                        <MenuItem value="extreme_weather">Extreme weather affecting site access</MenuItem>
                                                        <MenuItem value="health_safety">Health or safety issues at the property</MenuItem>
                                                        <MenuItem value="policy_conflict">Policy conflict</MenuItem>
                                                        <MenuItem value="payment_issues">Payment issues or failed transaction</MenuItem>
                                                        <MenuItem value="prior_misconduct">Prior misconduct or policy violations</MenuItem>
                                                        <MenuItem value="staffing_shortages">Staffing shortages affecting operations</MenuItem>
                                                        <MenuItem value="facility_issues">Power, water, or facility issues</MenuItem>
                                                        <MenuItem value="legal_changes">Legal or regulatory changes</MenuItem>
                                                        <MenuItem value="no_show">No Show</MenuItem>
                                                    </Select>
                                                </div>
                                                <div style={{ display: 'flex', marginTop: '5%', alignItems: 'center' }}>
                                                    <Typography style={{ marginRight: '5%' }}>Cancellation Charge</Typography>
                                                    <TextField id="cancellationCharge" label="Cancellation Charge" type="text"
                                                        onChange={(e) => {
                                                            if (/^(?!-)(\d{0,3}(\.\d{0,2})?)?$/.test(e.target.value)) {
                                                                this.setState({ cancellationCharge: e.target.value });
                                                            }
                                                        }}
                                                        value={this.state.cancellationCharge} inputProps={{ inputMode: 'numeric' }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', marginTop: '5%', alignItems: 'center' }}>
                                                    <Typography>
                                                        After hitting confirm, you will be taken to the transaction page where you can initiate a partial refund of ${this.state.cancellationCharge}.
                                                        An email notification will be automatically sent to the Guest if there is an email on file.
                                                    </Typography>
                                                </div>
                                            </>
                                            : null
                                        }
                                    </DialogContent>
                                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                            Cancel
                                        </Button>
                                        <Button onClick={this.handleConfirm} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                            Confirm
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={this.state.confirmationOpen} onClose={() => this.setState({ confirmationOpen: false })} classes={{ paper: classes.dialogPaper }}>
                                    <DialogTitle>{this.state.confirmationTitel}</DialogTitle>
                                    <DialogContent>
                                        {this.state.confirmationText}
                                    </DialogContent>
                                    <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button onClick={() => this.setState({ confirmationOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                            Close
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Box className='infoBox'>
                                    <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                                    <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                                </Box>

                                <Box className='box' style={{ marginTop: '-2%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={reservations} alt="Reservations" className='buttonImage' />
                                        <Typography className='reservationstypography' style={{ marginLeft: '5%' }}>
                                            Reservations
                                        </Typography>
                                    </div>
                                </Box>

                                <Box className='box'
                                    style={{ marginTop: '-3%' }}>
                                    <div className='buttonGroup'
                                    // style={{ width: "60%" }}
                                    >
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showReservations: false, showAllReservations: true }); this.filterClick('all'); }}>All Reservations</Button>
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showAllReservations: false, showReservations: true }); this.filterClick('groups'); }}>Groups</Button>
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showAllReservations: false, showReservations: true }); this.filterClick('reserved'); }}>Reserved</Button>
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showReservations: false, showCheckedInReservations: true }); this.filterClick('checkedIn'); }}>Checked In</Button>
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showReservations: false, showCheckedInReservations: true }); this.filterClick('checkingOut'); }}>Checking out</Button>
                                        <Button style={{ whiteSpace: "nowrap" }} className='button' onClick={() => { this.setState({ showReservations: false, showCheckedInReservations: true }); this.filterClick('review'); }}>In Review</Button>
                                    </div>

                                    {this.state.searchType === 'id'
                                        ?
                                        <>
                                            <SearchBar
                                                className='searchBox'
                                                placeholder='Search'
                                                value={this.state.searchValue}
                                                onChange={(newValue) => this.setState({ searchValue: newValue })}
                                                onRequestSearch={() => this.getReservationsByReservationNumber(this.state.searchValue)}
                                                cancelOnEscape={true}
                                                onCancelSearch={() => this.displayAllReservations()}
                                            />
                                        </>
                                        :
                                        <>
                                            <SearchBar
                                                className='searchBox'
                                                placeholder='e.g. reservation number, guest name, amount'
                                                value={this.state.searchValue}
                                                onChange={(newValue) => this.setState({ searchValue: newValue })}
                                                onRequestSearch={() => this.getReservationsByName(this.state.searchValue)}
                                                cancelOnEscape={true}
                                                onCancelSearch={() => this.displayAllReservations()}
                                            />
                                        </>
                                    }
                                </Box>
                            </ThemeProvider>
                            {/* <Box className='reservationTableHeadingBox'>
                                <Typography className='headerTypo'>Reservation #</Typography>
                                <Typography className='headerTypo'>Customer Name</Typography>
                                <Typography className='headerTypo'>Rig Type</Typography>
                                <Typography className='headerTypo'>Start Date</Typography>
                                <Typography className='headerTypo'>End Date</Typography>
                                <Typography className='headerTypo'>Site</Typography>
                                <Typography className='headerTypo'>Amount Paid</Typography>
                                <Typography className='headerTypo'>Amount Due</Typography>
                                <Typography className='headerTypo'>Status</Typography>
                                <Typography className='headerTypo'>Actions</Typography>
                            </Box> */}
                            <Box className='reservationTableHeadingBox'>
                                {[
                                    { key: 'id', label: 'Reservation #' },
                                    { key: 'first_name', label: 'Customer Name' },
                                    { key: 'rigname', label: 'Rig Type' },
                                    { key: 'startdate', label: 'Start Date' },
                                    { key: 'enddate', label: 'End Date' },
                                    { key: 'sitename', label: 'Site' },
                                    { key: 'amount_paid', label: 'Amount Paid' },
                                    { key: 'total', label: 'Amount Due' }
                                ].map((col) => (
                                <Typography
                                key={col.key}
                                className='headerTypo'
                                onClick={() => this.handleSort(col.key)}
                                style={{ cursor: 'pointer', position: 'relative' }}
                                >
                                    {col.label}
                                    {this.state.sortConfig.key === col.key ? (
                                <>
                                {this.state.sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽'}
                                </>
                            ) : ''}
                            </Typography>))}
                            <Typography className='headerTypo'>Status</Typography>
                            <Typography className='headerTypo'>Actions</Typography>
                            </Box>
                            {!this.state.noReservations && this.state.allReservations.length > 0
                                ?
                                <>
                                    <Box className='tableBox'>
                                        <table>
                                            <tbody>
                                                {reservationRows}
                                            </tbody>
                                        </table>
                                    </Box>
                                    <div className="pagination">
                                        {previousButton}
                                        {paginationButtons}
                                        ...
                                        {lastButton}
                                        {nextButton}
                                    </div>
                                </>
                                : <Typography className='headerTypo' style={{ fontSize: '1.5rem' }}>No Reservations Found</Typography>
                            }

                        </>
                        : <View serverName={this.props.serverName} viewItem={this.state.viewItem} goBack={this.goBack} user={this.props.user} />
                    }
                </Grid>
            );
        } else if (this.state.reservations.length === 0 && this.state.allReservations != null) {
            return (
                <>
                    <Grid className='reservationList'>
                        <Box className='infoBox'>
                            <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                            <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                        </Box>

                        <Box className='box' style={{ marginTop: '-2%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={reservations} alt="Reservations" className='buttonImage' />
                                <Typography className='reservationstypography' style={{ marginLeft: '5%' }}>
                                    Reservations
                                </Typography>
                            </div>
                        </Box>
                        <Typography style={{ marginTop: '2%', fontSize: '1.5rem' }}> You do not have any ongoing or future reservations</Typography>
                    </Grid>
                </>
            );
        } else {
            return (
                <CircularProgress className={classes.circularProgress} />
            );
        }
    };
};

export default withRouter(withStyles(useStyles)(Reservations));